import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as currentStatusActions from 'modules/currentStatus';

import classNames from 'classnames/bind';
import styles from './AdminPageTemplate.css';
const cx = classNames.bind(styles);

class AdminPageTemplate extends PureComponent {
  componentDidMount() {
    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.pageHeight(this.pageRef.clientHeight);
  }

  render() {
    const { children, className } = this.props;
    return (
      <div className={cx('admin-page-box', className)} ref={ref => (this.pageRef = ref)}>
        {children}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch)
});

export default connect(undefined, mapDispatchToProps)(AdminPageTemplate);



// WEBPACK FOOTER //
// ./src/script/components/admin/common/AdminPageTemplate.js